import { Grid, Typography } from "@mui/material";
import { FormikHelpers } from "formik";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import Layout from "../../../core/ui/layout/Layout";
import { useSendApiData } from "../../../core/hooks/useSendApiData";
import { toastError, toastMessage } from "../../../core/utils/ui/alert";
import { parseValidationErrors } from "../../../core/utils/validation";
import useFetchApiData from "../../../core/hooks/useFetchApiData";
import Loader from "../../../core/ui/utility/Loader";
import { CauseEdit, Cause } from "../cause";
import EditCauseForm from "../components/EditCauseForm";
import ReturnButton from "../../../core/ui/utility/ReturnButton";
import { parseFormQuery } from "../../../core/utils/utility";

const EditCauseContainer = () => {
  const { id } = useParams();
  const { callApi, loading: submitting } = useSendApiData();
  const { fetchData, loading } = useFetchApiData();
  const [cause, setCause] = useState<Cause | null>(null);

  const fetchCause = () =>
    fetchData(`causes/${id}`, {
      onSuccess: (data: Cause) => {
        setCause(data);
      },
    });

  useEffect(() => {
    fetchCause();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (
    values: CauseEdit,
    { setFieldError }: FormikHelpers<CauseEdit>
  ) => {
    const formData: any = parseFormQuery(values, ["deadline"])

    await callApi({
      endpoint: `auth-xaea12/causes/${id}?_method=PATCH`,
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onValidationError: (err) => parseValidationErrors(err, setFieldError),
      onError: toastError,
      onSuccess: async (_) => {
        await fetchCause();
        toastMessage('Cause Edited');
      },
    });
  };

  return (
    <Layout renderLeftToolbar={() => <ReturnButton to="/causes" />}>
      <Loader loading={loading || !cause}>
        <Grid sx={{ p: 2 }}>  
          <Grid container sx={{ mb: 1, px: 1 }}>
            <Typography variant="h5">Edit Cause</Typography>
          </Grid>
          <EditCauseForm cause={cause!} onSubmit={handleSubmit} submitting={submitting} />
        </Grid>
      </Loader>
    </Layout>
  );
};

export default EditCauseContainer;
